import urls from '../api_urls/webinar'
import { _post } from '@/axios/request'

// 获取webinar列表
export function getTableData (params) {
  return _post(urls.GET_WEBINAR_LIST, params)
}
// 获取webinar詳情
export function getDetail (params) {
  return _post(urls.GET_WEBINAR_DETAIL, params)
}
// 获取subscriber列表
export function getSubData (params) {
  return _post(urls.GET_SUBSCRIBER_LIST, params)
}
// 新增webinar
export const addWebinar = (params) => {
  return _post(urls.SAVE_WEBINAR, params)
}
// 更新webinar
export const updateWebinar = (params) => {
  return _post(urls.UPDATE_WEBINAR, params)
}
// 获取相关concept
export const getConcept = (params) => {
  return _post(urls.concept, params)
}

// 修改状态 2 启用 3 停用
export function changeStatus (params) {
  return _post(urls.CHANGE_STATEUS, params)
}

// 保存sample request
export function saveSample (params) {
  return _post(urls.SAVE_SAMPLE, params)
}

// 获取可导出的SampleRequest数量
export function getSampleRequestTotal (params) {
  return _post(urls.getSampleRequestTotal, params)
}
// 删除
export function del (params) {
  return _post(urls.del, params)
}


// WEBPACK FOOTER //
// ./src/axios/api/webinar.js